/**
 * Sending Messages Tracker
 *
 * Tracks which message local-IDs have been sent to prevent duplicate sends.
 * This prevents duplicates when a message exists in both
 * WebSocketBloc.messageQueue and ChatBloc.localMessages.
 *
 * Once a message is sent, we never send it again.
 * This is safe because local-IDs are unique and generated per message.
 */

const sentMessageIds = new Set<string>();

/**
 * Check if a message has already been sent (or is being sent)
 */
export function hasBeenSent(localId: string): boolean {
  return sentMessageIds.has(localId);
}

/**
 * Mark a message as sent (or being sent)
 * Returns false if the message was already marked as sent
 */
export function markAsSent(localId: string): boolean {
  if (sentMessageIds.has(localId)) {
    return false; // Already sent
  }
  sentMessageIds.add(localId);
  return true;
}

/**
 * Clear all tracking (useful for logout/cleanup to prevent cross-user contamination)
 */
export function clearSentMessages(): void {
  sentMessageIds.clear();
}

/**
 * Get count of messages that have been sent (for debugging/monitoring)
 */
export function getSentMessageCount(): number {
  return sentMessageIds.size;
}
